import * as React from "react";
import {option} from "ts-option";
import {api} from "../../../api/api";
import Modal from "../../ui/modal/Modal";
import SingleFileSelector from "../../file/SingleFileSelector";
import Toast from "../../helper/Toast";
import ImportResultsTile from "./ImportResultsTile";
import {ImportVehiclesResult} from "../../../model/importVehicles/ImportVehiclesResult";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

interface IComponentProps {
	/**
	 * On modal close.
	 */
	onClose: () => void;
}

interface IState {
	/**
	 * Indicates if files are uploading
	 */
	filesUploading: boolean;
	/**
	 * Upload errors to display
	 */
	errors: string[];
	/**
	 * Import results to display
	 */
	importResult: ImportVehiclesResult | null;
}

type Props = IComponentProps

export default class UploadMasterRegsCatalogModal extends React.PureComponent<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {filesUploading: false, errors: [], importResult: null};
		this.uploadFile = this.uploadFile.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Upload Master Catalog Regs"}>
				{!this.state.importResult ? (
					<SingleFileSelector onUpload={this.uploadFile}
										onCancel={this.props.onClose}
										errors={option(this.state.errors)}
										filesUploading={this.state.filesUploading}
										accept={".csv"}/>
				) : (
					<>
						<ImportResultsTile result={this.state.importResult}/>
						<div style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
							<ButtonPrimary label="Close" onClick={this.props.onClose}/>
						</div>
					</>
				)}
			</Modal>
		);
	}

	uploadFile(file: File) {
		if (file) {
			this.setState({filesUploading: true}, () => {
				api.instance.masterCatalogApi.uploadMasterCatalog(file).then((response) => {
					const result = ImportVehiclesResult.fromJson(response);
					Toast.success("Master catalog regs uploaded successfully.", "Master catalog regs upload");
					this.setState({filesUploading: false, importResult: result});
				}).catch((_: any) => {
					let errors: string[] = []
					this.setState({errors, filesUploading: false});
					Toast.error("Cannot upload master catalog regs.", "Master catalog regs upload");
				});
			});
		}
	}
}
